import React, { Component} from 'react';
import { FormattedMessage } from 'react-intl';
import Dropdown from "react-dropdown";
import Table from 'rc-table';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import "react-dropdown/style.css";

import axios from "axios";
import get from 'lodash/get';
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';

import PageTitle from 'shared/PageTitle';
import Auth from 'shared/Auth';
import Text from 'ui/Text';
import axiosClient from "utils/axios";
import { LanguageSubject } from 'shared/LanguageSubject';
import Button from '../../ui/Button';


class CSOSearchPage extends Component{
  constructor(){
    super();

    this.state = {
      current: 1,
      currentPageItemTotal: 0,
      csoApplicants: [],
      filteredCsoApplicants: [],
      filteredCSOs: [],
      loading: false,
      errorMessage: '',
      activeCategory: null,
      dropdownFocusAreas: [],
      dropdownSdgs: [],
      dropdownTypology: [],
      indicators: [],
      countries: [],
      filterOn: false,
      activeFilters: {},
      defaultTypology: {},
      defaultFocusArea: {},
      defaultSdg: {},
      defaultCountry: {},
      indicatorLabel: {
        fr: 'indicator_fr',
        en: 'indicator',
      },
      countryLabel: {
        fr: 'Name_fr',
        en: 'Name',
      }     
    }

    this.axiosHandler = axios.CancelToken.source();
    this.languageSubjectListener = null;
  }

  componentDidMount(){
    this.languageSubjectListener = LanguageSubject.subscribe(() => {
      const defaultLang = get(Auth.getLanguage(), 'local_locale');
      
      let dropdownFocusAreas = [], dropdownSdgs = [], dropdownTypology = [];

      this.state.indicators.forEach((indicator) => {
        let indicatorType = get(indicator, 'indicator_type');

        if (indicatorType === "focus_areas") {
          dropdownFocusAreas = [...dropdownFocusAreas, {
            label: get(indicator, get(this.state.indicatorLabel, defaultLang)),
            value: get(indicator, 'field_id')
          }];
        } else if (indicatorType === "typology") {
          dropdownTypology = [...dropdownTypology, {
            label: get(indicator, get(this.state.indicatorLabel, defaultLang)),
            value: get(indicator, 'field_id')
          }];
        } else {
          dropdownSdgs = [...dropdownSdgs, {
            label: get(indicator, get(this.state.indicatorLabel, defaultLang)),
            value: get(indicator, 'choice_id')
          }];
        }
      });
      
      let dropdownCountries = this.state.countries.map(country => ({
        label: get(country, get(this.state.countryLabel, defaultLang)),
        value: get(country, 'Code')
      }));

      let labelVal = {
        en: 'View All',
        fr: 'Voir tous',
      }

      let firstOption = {
        label: get(labelVal, defaultLang),
        value: '',
      };

      dropdownFocusAreas = [firstOption, ...dropdownFocusAreas];

      dropdownTypology = [firstOption, ...dropdownTypology];      

      dropdownSdgs = [firstOption, ...dropdownSdgs];

      this.setState({
        dropdownFocusAreas,
        dropdownSdgs,
        dropdownCountries,
        dropdownTypology,
      });
    });    
    this.loadData();
  }

  componentWillUnmount() {
    this.axiosHandler.cancel("Unmounting component");

    if (this.languageSubjectListener !== null) {
      this.languageSubjectListener.unsubscribe();
      this.languageSubjectListener = null;
    }    
  }  

  loadData = () => {
    this.setState({ loading: true });

    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    let coutries = axiosClient
      .get(`/country`, { cancelToken: this.axiosHandler.token })
      .then(response => {
        return [
          { 
            Name: 'View All', 
            Name_fr: 'Voir tous',
            Code: ''
          } ,...response.data
        ];
      });

    let indicators = axiosClient
      .get(`/field/indicator`, { cancelToken: this.axiosHandler.token })
      .then(response => {
        return get(response.data, "returned_resultset", []);
      });

    Promise.all([coutries, indicators])
        .then(([countries, indicators]) => {
          let dropdownFocusAreas = [], dropdownSdgs = [], dropdownTypology = [];

          indicators.forEach((indicator) => {
            let indicatorType = get(indicator, 'indicator_type');

            if (indicatorType === "focus_areas"){
              dropdownFocusAreas = [...dropdownFocusAreas, {
                label: get(indicator, get(this.state.indicatorLabel, defaultLang)),
                value: get(indicator, 'field_id')
              }];
            } else if (indicatorType === "typology") {
              dropdownTypology = [...dropdownTypology, {
                label: get(indicator, get(this.state.indicatorLabel, defaultLang)),
                value: get(indicator, 'field_id')
              }];
            } else {
              dropdownSdgs = [...dropdownSdgs, {
                label: get(indicator, get(this.state.indicatorLabel, defaultLang)),
                value: get(indicator, 'choice_id')
              }];
            }
          });
          
          let dropdownCountries = countries.map(country => ({
            label: get(country, get(this.state.countryLabel, defaultLang)),
            value: get(country, 'Code')
          }));

          let labelVal = {
            en: 'View All',
            fr: 'Voir tous',
          };

          let firstOption = {
            label: get(labelVal, defaultLang),
            value: '',
          };

          dropdownFocusAreas = [firstOption, ...dropdownFocusAreas];

          dropdownTypology = [firstOption, ...dropdownTypology];          

          dropdownSdgs = [firstOption, ...dropdownSdgs];

          this.setState({
            dropdownFocusAreas,
            dropdownSdgs,
            dropdownTypology,
            dropdownCountries,
            countries,
            loading: false,
            indicators,
          });             
        }).catch(error => {
          this.setState({
            loading: false,
            errorMessage:
              get(error, 'response.data.message')
              || 'Could not proceed. There was an issue retrieveing the fields.',
          });
        });   
  };

  serialize = obj => {
    let str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        let objectItem = obj[p];
        
        if (objectItem){
          let filterItem = `${encodeURIComponent(p)}=${encodeURIComponent(
            get(objectItem, 'value')
          )}`;

          str.push(filterItem);
        }
      }
    return str.join("&");
  };  
  
  filterUsers = (option = {}, filterKey, fieldKey) => {
    this.setState({
      activeFilters: {
        ...this.state.activeFilters,
        [filterKey]: option,
      },
      filterOn: true,
      [fieldKey]: option,
      loading: true
    }, () => {
      let filterParams = this.serialize(this.state.activeFilters);
      let newParams = `${filterParams}`.replace('_2', '');
      this.getUsers(newParams);
    });
  }

  getUsers = (filters = '') => {
    this.setState({ loading: true, csoApplicants: []});

    axiosClient
      .get(`/user/response?${filters}`, {
        cancelToken: this.axiosHandler.token
      })
      .then(response => {
        const itemTotal = 10;
        let csoApplicants = orderBy(get(response.data, "returned_resultset", []), ['user.organisation'], ['asc']);
        let filteredCsoApplicants = [...csoApplicants].slice(0, itemTotal);

        this.setState({
          csoApplicants,
          currentPageItemTotal: csoApplicants.length > itemTotal ? itemTotal : csoApplicants.length,
          filteredCsoApplicants,
          loading: false
        });
      })
      .catch(error => {
        this.setState({
          loading: false,
          errorMessage:
            get(error, 'response.data.message')
            || 'Could not proceed. There was an issue retrieveing the users.',
        });
      });
  }

  getAttribute = (attributes = [], keyName, keyNameFrench) => {
    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    const backgroundInfo = {
      fr: `${keyNameFrench}`,
      en: `${keyName}`,
    };

    let areaOfFocus = find(attributes, ['attribute.name', get(backgroundInfo, defaultLang)]);

    return `${get(areaOfFocus, 'value', '')}`.trim();
  }

  onPageReload = (page) => {
    const totalItems = 10;

    let startPage = (page * totalItems) - totalItems;
    let offSet = (page * totalItems);
    let filteredCsoApplicants = [...this.state.csoApplicants].slice(startPage, offSet);

    let currentPageItemTotal = this.state.csoApplicants.length > offSet ? offSet : this.state.csoApplicants.length; 

    this.setState({
      current: page,
      filteredCsoApplicants,
      currentPageItemTotal
    });
  }  

  removeFilter = (filterKey, dropdownDefault) => {
    let activeFilters = {
      ...this.state.activeFilters,
      [filterKey]: ''
    };
  
    this.setState({
      [dropdownDefault]: '', 
      activeFilters,
    }, () => {
        let filterParams = this.serialize(this.state.activeFilters);
        let newParams = `${filterParams}`.replace('_2', '');

        newParams.length ? this.getUsers(newParams) : this.setState({ filteredCsoApplicants: [], csoApplicants: []});
    });
  }

  
  render() {
    let activeFilters = Object.keys(this.state.activeFilters).map((key) => 
      get(this.state.activeFilters, key) ? <span className="filter-pill">
          {get(get(this.state.activeFilters, key), 'label')}
        </span> : null
    );

    const { 
      csoApplicants, 
      filteredCsoApplicants,
      dropdownFocusAreas,
      dropdownSdgs,
      dropdownCountries,
      loading,
      defaultFocusArea,
      defaultSdg,
      dropdownTypology,
      defaultCountry,
      defaultTypology,
      filterOn,
      current,
      currentPageItemTotal } = this.state;

    const columns = [{
      title: <FormattedMessage id="Form.Country" defaultMessage="Country"/>, 
      width: "20%",
      render: (t, csoDetail) => <span>{
        get(csoDetail, 'user.country_name', []) ? get(csoDetail, 'user.country_name', [])  : null
      }</span>,
    }, {
      title: <FormattedMessage id="CSOShortlist.Name" defaultMessage="Name"/>,
      dataIndex: 'name', 
      width: "20%",
        render: (t, csoDetail) => <span className="organisation-name">{get(csoDetail, 'user.organisation')}</span>,
    }, {
      title: <FormattedMessage id="CSOShortlist.AreaOfFocus" defaultMessage="Area Of Focus"/>, 
      dataIndex: 'area_of_focus', 
      width: "20%",
      render: (t, csoDetail) => <span>{
        this.getAttribute(get(csoDetail, 'user.attributes', []), 'area_of_focus', 'area_of_focus_french') ? this.getAttribute(get(csoDetail, 'user.attributes', []), 'area_of_focus', 'area_of_focus_french')
        : get(defaultFocusArea, 'value') ? get(defaultFocusArea, 'label') : 'N/A'
      }</span>,
    }, {
      title: <FormattedMessage id="CSOShortlist.Typology" defaultMessage="Typology"/>,
      dataIndex: 'typology',
      width: "20%",
      render: (t, csoDetail) => <span>{
        this.getAttribute(get(csoDetail, 'user.attributes', []), 'typology', 'typology_fr') ? this.getAttribute(get(csoDetail, 'user.attributes', []), 'typology', 'typology_fr') : get(defaultTypology, 'value') ? get(defaultTypology, 'label') : 'N/A'
      }</span>,
    }, {
      title: <FormattedMessage id="CSOShortlist.SDG" defaultMessage="SDG"/>,
      dataIndex: 'sdg',
      width: "20%", 
      render: (t, csoDetail) => <span>{
        this.getAttribute(get(csoDetail, 'user.attributes', []), 'sdg_value', 'sdg_value_fr') ? this.getAttribute(get(csoDetail, 'user.attributes', []), 'sdg_value', 'sdg_value_fr')
         : get(defaultSdg, 'value') ? get(defaultSdg, 'label') : 'N/A'
      }</span>,
    }];

    return (
      <div id="search-csos">
        <PageTitle title="Shortlisted CSOs" />
        <div>
          <div className="inner-content shortlisted-csos">
            <div className="search-hero explanations-area">
              <Text type="heading-semi-bold" modifiers="text-center title heavy col-sm-12 col-md-7 center-block">
                <FormattedMessage id="CSOSearchPage.Title" defaultMessage="EPIC-Africa Database of African Civil Society Organizations" />
              </Text>
              <br/>
              <Text type="explanation" modifiers="text-center">
                <FormattedMessage id="CSOSearchPage.Description" defaultMessage={`
                  This database is a growing resource for institutions and individuals seeking to find, 
                  vet and support African CSOs. It consists of close to 400 organizations,ranging from 
                  think tanks to direct service delivery groups across 46 African countries. Please 
                  contact EPIC-Africa at`} />
                <a className="email-link" href="mailto:admin@epic-africa.org">admin@epic-africa.org</a>
                <FormattedMessage id="CSOSearchPage.Description.2" defaultMessage={`to learn more 
                  and to receive more in-depth country or sector level mapping including 
                  information such as number of employees, budget, legal status and 
                  adherence to organizational best practices.`}/>
              </Text>              
            </div>
            <div className="row no-margin" style={{paddingBottom: '3rem'}}>
              {
                loading && !dropdownFocusAreas.length ?
                  <div className="col-sm-12">
                    <Text type="sub-head-bold" modifiers="loader-animation shorlist-loader filter-cta">
                      <FormattedMessage
                        id="CSOSearchPage.Loading"
                        defaultMessage="Loading..."
                      />
                    </Text>
                  </div> : null
              }                            
              <div className="col-3 cso-filters">
                {
                  dropdownFocusAreas.length ? (
                    <div className="cso-filter-wrapper">
                      <div className="cso-filter-container">
                        <Text type="explainer" modifiers="explanations-area">
                          <FormattedMessage
                            id="CSOSearchPage.Explainer"
                            defaultMessage="Filter by Country"
                          />
                        </Text>
                        <Dropdown
                          className="category-filter-container"
                          classNamePrefix="category-filter"
                          placeholder="Select a Country"
                          value={defaultCountry}
                          options={dropdownCountries}
                          onChange={(ev) => this.filterUsers(ev, 'country_code', 'defaultCountry')}
                        />
                        {
                          get(this.state , 'defaultCountry.label') ? (
                            <Text 
                              type="small" 
                              onClick={() => this.removeFilter('country_code', 'defaultCountry')} 
                              modifiers="pill">
                              Clear
                            </Text>
                          ) : <span className="spacer"/>  
                        }
                      </div>
                      <div className="cso-filter-container">
                        <Text type="explainer" modifiers="explanations-area">
                          <FormattedMessage
                            id="CSOSearchPage.AreaOfFocus"
                            defaultMessage="Filter by Area of Focus"
                          />
                        </Text>
                        <Dropdown
                          className="category-filter-container"
                          classNamePrefix="category-filter"
                          placeholder="Select a Category"
                          value={defaultFocusArea}
                          options={dropdownFocusAreas}
                          onChange={(ev) => this.filterUsers(ev, 'field_id', 'defaultFocusArea')}
                        />
                        {
                          get(this.state, 'defaultFocusArea.label') ? (
                            <Text
                              type="small"
                              onClick={() => this.removeFilter('field_id', 'defaultFocusArea')}
                              modifiers="pill">
                              Clear
                            </Text>
                          ) : <span className="spacer" />
                        }
                      </div>
                      <div className="cso-filter-container">
                        <Text type="explainer" modifiers="explanations-area">
                          <FormattedMessage
                            id="CSOSearchPage.Typology"
                            defaultMessage="Filter by Typology"
                          />
                        </Text>
                        <Dropdown
                          className="category-filter-container"
                          classNamePrefix="category-filter"
                          placeholder="Select a Typology"
                          value={defaultTypology}
                          options={dropdownTypology}
                          onChange={(ev) => this.filterUsers(ev, 'field_id_2', 'defaultTypology')}
                        />
                        {
                          get(this.state, 'defaultTypology.label') ? (
                            <Text
                              type="small"
                              onClick={() => this.removeFilter('field_id_2', 'defaultTypology')}
                              modifiers="pill">
                              Clear
                            </Text>
                          ) : <span className="spacer" />
                        }                      
                      </div>                                                                
                      <div className="cso-filter-container">
                        <Text type="explainer" modifiers="explanations-area">
                          <FormattedMessage
                            id="CSOSearchPage.SDG"
                            defaultMessage="Filter by SDG"
                          />
                        </Text>
                        <Dropdown
                          className="category-filter-container"
                          classNamePrefix="category-filter"
                          placeholder="Select an SDG"
                          value={defaultSdg}
                          options={dropdownSdgs}
                          onChange={(ev) => this.filterUsers(ev, 'choice_id', 'defaultSdg')}
                        />
                        {
                          get(this.state, 'defaultSdg.label') ? (
                            <Text
                              type="small"
                              onClick={() => this.removeFilter('choice_id', 'defaultSdg')}
                              modifiers="pill">
                              Clear
                            </Text>
                          ) : <span className="spacer" />
                        }                      
                      </div>
                    </div>
                  ) : null
                }
              </div>
              <div className="col-9">
                {
                  filteredCsoApplicants.length && !loading ? (
                    <div>
                      <Text type="normal-bold" modifiers="total-indicator">
                        {currentPageItemTotal} of {csoApplicants.length} organisations
                      </Text>
                      <div>
                        <Text type="normal-bold" modifiers="total-indicator">
                          Active Filters (click clear to remove): {activeFilters}
                        </Text>
                      </div>
                      <Table 
                        className="table table-stripped" 
                        columns={columns}
                        rowKey="id"
                        emptyText={<Text type="sub-head-bold" modifiers="filter-cta">
                          <FormattedMessage id="CSOSearchPage.NotFound" defaultMessage="No CSOs have been found" />
                        </Text>}
                        data={filteredCsoApplicants} />
                      <div className="pagination-container">
                        <Pagination onChange={this.onPageReload} current={current} total={csoApplicants.length || 10} />
                      </div>
                    </div>
                  ) : null
                }
                {
                  !loading && !filterOn ? (
                    <Text type="sub-head-bold" modifiers="filter-cta">
                      <FormattedMessage
                        id="CSOSearchPage.SearchCTO"
                        defaultMessage="Select a Filter to List CSOs"
                      />
                    </Text>
                  ) : null
                }
                {
                  !filteredCsoApplicants.length && !loading && filterOn ?
                    <div className="filter-cta">
                      <Text type="sub-head-bold">
                        <FormattedMessage id="CSOSearchPage.NotFound" defaultMessage="No CSOs have been found" />
                      </Text>
                      <Text type="sub-head" modifiers="helper-text">
                        <FormattedMessage id="CSOSearchPage.ClearFilters" defaultMessage="Please try to clear or add some filters to enhance your search." />
                      </Text>
                    </div>
                  : null
                }
                {
                  loading && filterOn ?
                    <Text type="sub-head-bold" modifiers="filter-cta loader-animation shorlist-loader">
                      <FormattedMessage
                        id="CSOSearchPage.Loading"
                        defaultMessage="Loading..."
                      />
                    </Text>
                    : null
                }                                 
              </div>              
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default CSOSearchPage;


// WEBPACK FOOTER //
// ./src/components/HomePage/CSOSearchPage.js